import { StaffAvailabilitySchedule } from "~/types/staff-availability-schedule";
import { baseService } from "../base";
import { PaginationParams, PaginationResponse } from "../type";
import { StaffAvailability } from "~/utils/constants";

export interface CreateAvailabilityScheduleDto {
  date: string;
  availability: StaffAvailability;
  note?: string;
  staffId: string;
}

export interface UpdateAvailabilityScheduleDto {
  id: string;
  date?: string;
  availability?: StaffAvailability;
  note?: string;
  staffId?: string;
}

export interface GetAvailabilityScheduleParams extends PaginationParams {
  staffId?: string;
  startDate?: string;
  endDate?: string;
  availability?: StaffAvailability;
}

export const staffAvailabilityServices = {
  getAvailabilities: async (params?: GetAvailabilityScheduleParams) => {
    const { data } = await baseService.get<PaginationResponse<StaffAvailabilitySchedule>>(
      "/staff-availability-schedule",
      { params }
    );
    return data;
  },
  
  getAvailabilityById: async (id: string) => {
    const { data } = await baseService.get<StaffAvailabilitySchedule>(
      `/staff-availability-schedule/${id}`
    );
    return data;
  },
  
  createAvailability: async (schedule: CreateAvailabilityScheduleDto) => {
    const { data } = await baseService.post<StaffAvailabilitySchedule>(
      "/staff-availability-schedule",
      schedule
    );
    return data;
  },
  
  updateAvailability: async (id: string, schedule: UpdateAvailabilityScheduleDto) => {
    const { data } = await baseService.patch<StaffAvailabilitySchedule>(
      `/staff-availability-schedule/${id}`,
      schedule
    );
    return data;
  },
  
  deleteAvailability: async (id: string) => {
    await baseService.delete(`/staff-availability-schedule/${id}`);
  },
  
  createAvailabilityList: async (schedules: CreateAvailabilityScheduleDto[]) => {
    const { data } = await baseService.post<StaffAvailabilitySchedule[]>(
      "/staff-availability-schedule/create-list",
      schedules
    );
    return data;
  },
  
  updateAvailabilityList: async (schedules: UpdateAvailabilityScheduleDto[]) => {
    const { data } = await baseService.post<StaffAvailabilitySchedule[]>(
      "/staff-availability-schedule/update-list",
      schedules
    );
    return data;
  }
};